export function formatEstimatedMinutes(
    minutes: number | null | undefined,
): string | null {
    if (minutes == null) {
        return null;
    }

    if (minutes < 60) {
        return `${minutes} min`;
    }

    const hours = Math.floor(minutes / 60);
    const remaining = minutes % 60;

    if (remaining === 0) {
        return `${hours} hr`;
    }

    return `${hours} hr ${remaining} min`;
}
